import { cx } from "cva";
import React from "react";

import CircularProgress from "../CircularProgress";
import { ButtonProps, variants } from "./";

export const Button = ({
  className,
  disabled,
  children,
  type = "button",
  variant,
  color,
  loading,
  ...props
}: Readonly<ButtonProps>) => (
  <button
    disabled={disabled || loading}
    type={type}
    className={cx(className, variants({ variant, color, loading }))}
    {...props}
  >
    {loading ? <CircularProgress /> : children}
  </button>
);
